import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import { isGearType } from '@/types/lootTypes';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
import math from 'mathjs';
const equipmentModule = namespace('equipment');
let LootGear = class LootGear extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Adventuring Gear';
    }
    created() {
        this.fetchEquipment();
        this.initialSearch = this.$route.query.search;
    }
    customSort(items, sortBy, sortDesc) {
        items.sort((a, b) => {
            if (sortBy[0] === 'weight' && parseFloat(a[sortBy[0]]) && parseFloat(b[sortBy[0]])) {
                if (!sortDesc[0]) {
                    return math.eval(a[sortBy[0]]) < math.eval(b[sortBy[0]]) ? -1 : 1;
                }
                else {
                    return math.eval(b[sortBy[0]]) < math.eval(a[sortBy[0]]) ? -1 : 1;
                }
            }
            else {
                if (!sortDesc[0]) {
                    return (a[sortBy[0]]) < (b[sortBy[0]]) ? -1 : 1;
                }
                else {
                    return (b[sortBy[0]]) < (a[sortBy[0]]) ? -1 : 1;
                }
            }
        });
        return items;
    }
    get items() {
        return _(this.equipment)
            .filter(isGearType)
            .map(equipment => ({
            ...equipment,
            id: equipment.name,
            isExpandable: equipment.description
        })).value();
    }
    get categories() {
        return _(this.items).map(({ equipmentCategory }) => (_.startCase(equipmentCategory))).compact().sortBy().uniq().value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Category',
                value: 'equipmentCategory',
                render: _.startCase,
                filterChoices: this.categories,
                filterFunction: ({ equipmentCategory }, filterValue) => _.startCase(equipmentCategory) === filterValue
            },
            { text: 'Cost', value: 'cost' },
            { text: 'Weight (lb)', value: 'weight' },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    equipmentModule.State
], LootGear.prototype, "equipment", void 0);
__decorate([
    equipmentModule.Action
], LootGear.prototype, "fetchEquipment", void 0);
LootGear = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], LootGear);
export default LootGear;
